import styled from 'styled-components';

import { Modal } from 'shared/components/modal/Modals';
import { colors, fonts, fontSizes, device } from 'shared/defaultTheme';
import BackgroundBox from 'shared/components/BackgroundBox';

export const DocumentWrapper = styled.div`
  @media ${device.sm} {
    display: block;
    .collapse-client-container {
      margin-left: 9px;
      margin-bottom: 10px;
    }
  }
  @media ${device.md} {
    display: block;
    .collapse-client-container {
      margin-left: 9px;
      margin-bottom: 10px;
    }
  }
  @media ${device.lg} {
    display: block;
    .collapse-client-container {
      margin-left: 9px;
      margin-bottom: 10px;
    }
  }
  @media ${device.xl} {
    display: flex;
    .collapse-client-container {
      margin-left: 0;
      margin-bottom: 0;
    }
  }
  .collapse-client-container {
    height: 48px;
    width: 48px;
    border-radius: 2px;
    background-color: ${colors.white};
    box-shadow: 0 0 15px 0 ${colors.mercury};
    display: flex;
    justify-content: center;
  }
`;

export const DocumentPanelBackground = styled(BackgroundBox)`
  padding-bottom: 25px;
  font-family: ${fonts.medium};
  font-size: ${fontSizes.sm}px;
  @media ${device.sm} {
    flex: 0 0 97%;
    width: 97%;
    margin-left: 5px;
    margin-bottom: 11px;
    padding: 10px;
  }
  @media ${device.md} {
    flex: 0 0 98%;
    width: 98%;
    margin-left: 10px;
    margin-bottom: 11px;
  }
  @media ${device.lg} {
    flex: 0 0 98%;
    width: 98%;
    margin-left: 10px;
    margin-bottom: 11px;
  }
  @media ${device.xl} {
    flex: 0 0 20%;
    font-family: ${fonts.medium};
    font-size: ${fontSizes.sm}px;
    margin-bottom: 0;
    margin-left: 0;
    padding: 0;
  }
`;
export const DocumentTableBackground = styled(BackgroundBox)`
  @media ${device.sm} {
    flex: 0 0 97%;
    width: 97%;
    margin-left: 5px;
  }
  @media ${device.md} {
    flex: 0 0 98%;
    width: 98%;
    margin-left: 11px;
  }
  @media ${device.lg} {
    flex: 0 0 98%;
    width: 98%;
    margin-left: 11px;
  }
  @media ${device.xl} {
    flex: ${({ isCustomer, isCollapse }) => (isCustomer && !isCollapse ? '0 0 75%' : '0 0 90%')};
    width: 100px;
    margin-left: 7px;
  }
  .e-upload.e-control-wrapper {
    display: none;
  }
`;

export const NotifiFormModal = styled(Modal)`
  top: 15%;
  .modal-content {
    border-radius: 4px;
  }
  .modal-header {
    border: 0;
    height: 36px;
    padding-top: 20px;
    padding-bottom: 0;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }
    .div-icon-wrapper {
      width: 26%;
      height: 35px;
    }
  }
  .modal-body {
    padding: 0.6rem;
  }
`;

export const PublicFormModal = styled(Modal)`
  top: 8%;
  .modal-content {
    border-radius: 4px;
  }
  .modal-header {
    border: 0;
    height: 36px;
    padding-top: 20px;
    padding-bottom: 0;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }
    .div-icon-wrapper {
      width: 26%;
      height: 35px;
    }
  }
  .modal-body {
    padding: 0.6rem;
  }
`;

export const CollapseClient = styled.div`
  border-radius: 18px;
  background-color: ${colors.gullGrey};
  margin-top: 10px;
  margin-right: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 27px;
  width: 27px;
  svg {
    fill: ${colors.white};
    height: 16px;
    width: 27px;
  }
`;

export const CollapseClientRight = styled.div`
  border-radius: 18px;
  background-color: ${colors.gullGrey};
  margin-top: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 27px;
  width: 27px;
  svg {
    fill: ${colors.white};
    height: 16px;
    width: 27px;
  }
`;
